export const GET_APPOINTMENT_UNITS_REQUEST = 'GET_APPOINTMENT_UNITS_REQUEST';
export const GET_APPOINTMENT_UNITS_SUCCESS = 'GET_APPOINTMENT_UNITS_SUCCESS';
export const GET_APPOINTMENT_UNITS_FAILURE = 'GET_APPOINTMENT_UNITS_FAILURE';

